import * as React from 'react'
import { observer } from 'mobx-react'
import { Modal, Button } from 'antd-v4'

interface Props {
  visible: boolean
  onHide: () => void
}

@observer
export class EditPurchasePriceModal extends React.Component<Props> {
  constructor(props: Props) {
    super(props)
  }

  render() {
    return (
      <Modal
        visible={this.props.visible}
        title='Edit purchase price'
        onCancel={() => this.props.onHide()}
        footer={
          <Button className='w-100' onClick={() => this.props.onHide()}>
            I understand
          </Button>
        }
      >
        <p>
          <span>Your store is set to use </span>
          <strong>weighted average</strong>
          <span> costs.</span>
        </p>
        <p>
          If you edit your costs now, your purchase price will be reset to your new purchase price
          input and replace the calculated weighted average cost.
        </p>
      </Modal>
    )
  }
}
